// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Card */
.card {
  margin-bottom: 30px;
  border: none;
  border-radius: 5px;
  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);
}

.card-header,
.card-footer {
  border-color: #ebeef4;
  background-color: #fff;
  color: #798eb3;
  padding: 15px;
}

.user-webnexs .card-title {
  padding: 20px 0 15px 0;
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  font-family: "Poppins", sans-serif;
}

.user-webnexs span.small.pt-1.fw-bold {
  color: black;
}

.card-title span {
  color: #899bbd;
  font-size: 14px;
  font-weight: 400;
}

.card-body {
  padding: 0 20px 20px 20px;
}

.card-img-overlay {
  background-color: rgba(255, 255, 255, 0.6);
}

.dashboard .nav-link {
  border-radius: 5px;
  border-bottom: 1px solid #e9e6e6;
  font-weight: 500;
  color: #000000;
  background-color: #e1e1e1;
}

.dashboard .nav-link.active {
  background: rgb(255 255 255 / 20%);
  font-size: 16px;
  font-weight: 500;
  color: #000;
}

.upload-video {
  background-color: #fafafa;
  padding: 10px;
  border-radius: 10px;
}

.iq-card {
  background: #fff;
  border-radius: 5px;
  margin-bottom: 30px;
  border: none;
  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);
  border-radius: 5px;
}



.testtestvideo>th:nth-child(1) {
  width: 10%;
  position: relative;
}
.testtestvideo>th:nth-child(2) {
  width: 20%;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/Pages/LogActivity/Cache_Management/SeeLogActivity.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;;EAEE,qBAAqB;EACrB,sBAAsB;EACtB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAGhB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;AACpB;;;;AAIA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB","sourcesContent":["/* Card */\n.card {\n  margin-bottom: 30px;\n  border: none;\n  border-radius: 5px;\n  box-shadow: 0px 0 30px rgba(1, 41, 112, 0.1);\n}\n\n.card-header,\n.card-footer {\n  border-color: #ebeef4;\n  background-color: #fff;\n  color: #798eb3;\n  padding: 15px;\n}\n\n.user-webnexs .card-title {\n  padding: 20px 0 15px 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: #000000;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.user-webnexs span.small.pt-1.fw-bold {\n  color: black;\n}\n\n.card-title span {\n  color: #899bbd;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.card-body {\n  padding: 0 20px 20px 20px;\n}\n\n.card-img-overlay {\n  background-color: rgba(255, 255, 255, 0.6);\n}\n\n.dashboard .nav-link {\n  border-radius: 5px;\n  border-bottom: 1px solid #e9e6e6;\n  font-weight: 500;\n  color: #000000;\n  background-color: #e1e1e1;\n}\n\n.dashboard .nav-link.active {\n  background: rgb(255 255 255 / 20%);\n  font-size: 16px;\n  font-weight: 500;\n  color: #000;\n}\n\n.upload-video {\n  background-color: #fafafa;\n  padding: 10px;\n  border-radius: 10px;\n}\n\n.iq-card {\n  background: #fff;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n  margin-bottom: 30px;\n  border: none;\n  box-shadow: 0px 4px 20px rgb(0 0 0 / 5%);\n  border-radius: 5px;\n}\n\n\n\n.testtestvideo>th:nth-child(1) {\n  width: 10%;\n  position: relative;\n}\n.testtestvideo>th:nth-child(2) {\n  width: 20%;\n  position: relative;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
